import { AskBrainData } from "../../../../api/askBrainTyped/AskBrain";
import { CustomApiTransformUtil } from "../util/CustomApiTransformUtil";
import { GlobalResponse } from "../../../../cutil/GlobalClient";
import { RunStreamResponse } from "../../../../storyV2/function/FunctionBase";
import { WebsocketResponse } from "../../../../storyV2/model/WebsocketResponse";
import { JsonUtil } from "../../../../cutil/JsonUtil";
export class ChainRequest {
    constructor(query, res, result = null) {
        this.query = query;
        this.res = res;
        this.result = result;
    }
    get isWS() {
        if (this.res instanceof WebsocketResponse) {
            return true;
        }
        return false;
    }
    get response() {
        if (this.res instanceof GlobalResponse) {
            return Promise.resolve(this.res.response);
        }
        return Promise.reject();
    }
    get isStream() {
        if (this.res instanceof GlobalResponse) {
            return this.res.isStream;
        }
        return false;
    }
    get contentType() {
        if (this.res instanceof GlobalResponse) {
            const type = this.res.headers?.get("Content-Type");
            if (type) {
                return type;
            }
        }
        return undefined;
    }
    get websocketContent() {
        if (this.res instanceof WebsocketResponse) {
            return this.res.content;
        }
        return undefined;
    }
    get websocketHtml() {
        if (this.res instanceof WebsocketResponse) {
            return this.res.html;
        }
        return undefined;
    }
    get websocketAskBrain() {
        if (this.res instanceof WebsocketResponse) {
            return JsonUtil.toModelFromType(AskBrainData, this.res.ask_brain);
        }
        return undefined;
    }
    get websocketFileParams() {
        if (this.res instanceof WebsocketResponse) {
            return this.res.fileParams;
        }
        return undefined;
    }
    get displayType() {
        if (this.res instanceof GlobalResponse) {
            return CustomApiTransformUtil.getDisplayTypeByHeaders(this.res.headers);
        }
        else {
            return this.res.displayType;
        }
    }
    get hasNodeDisplayType() {
        if (this.res instanceof GlobalResponse) {
            return CustomApiTransformUtil.getNodeDisplayTypeByHeaders(this.res.headers) !== undefined;
        }
        return false;
    }
    json() {
        if (this.res instanceof GlobalResponse) {
            return this.res.json();
        }
        return Promise.reject();
    }
    text() {
        if (this.res instanceof GlobalResponse) {
            return this.res.text();
        }
        return Promise.reject();
    }
    blob() {
        if (this.res instanceof GlobalResponse) {
            return this.res.blob();
        }
        return Promise.reject();
    }
    stream(handler) {
        if (this.res instanceof GlobalResponse) {
            const response = this.res.stream;
            if (!response) {
                return undefined;
            }
            const streamResponse = new RunStreamResponse();
            let onReceived = (msg) => {
                if (msg.done) {
                    msg.abort();
                }
                const fullText = msg.fullText.trim();
                if (handler) {
                    streamResponse.receive(handler(fullText), msg.done);
                }
                else {
                    streamResponse.receive(fullText, msg.done);
                }
            };
            response.onReceived(re => onReceived(re));
            return streamResponse;
        }
        return undefined;
    }
    updateResponse(res) {
        this.res = res;
    }
    setResult(res) {
        this.result = res;
    }
    getResult() {
        return this.result;
    }
}
